import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-cream py-16 px-4 md:px-8 lg:px-16 overflow-hidden" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="space-y-8" data-id="element-49">
          {/* 1. Headline */}
          <motion.h1 variants={itemVariants} className="text-2xl md:text-3xl lg:text-4xl font-serif font-extrabold text-navy leading-tight text-center" data-id="element-50">
            DEJÁ DE TERMINAR EL DÍA AGOTADA PELEANDO CON TU HIJO.
          </motion.h1>

          {/* 2. Product image */}
          <motion.div variants={itemVariants} className="flex justify-center" data-id="element-51">
            <img src="https://cdn.magicpatterns.com/uploads/w1ZyEmc75NuFywXGRsJZt3/1.png" alt="Pack Reconexión Familiar Total" className="w-full max-w-sm h-auto object-contain drop-shadow-2xl" data-id="element-52" />
          </motion.div>

          {/* 3. Subheadline */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl text-gray-700 font-sans text-center max-w-2xl mx-auto" data-id="element-53">
            El primer sistema práctico de reconexión rápida que te da el "paso a
            paso" para recuperar la confianza de tu adolescente en 7 días y
            volver a dormir tranquila.
          </motion.p>

          {/* 4. CTA Button */}
          <motion.div variants={itemVariants} className="flex justify-center pt-2" data-id="element-54">
            <CTAButton className="w-full sm:w-auto text-lg md:text-xl" href="#pricing" onClick={scrollToPricing} data-id="element-55">
              <span className="block" data-id="element-56">[ACCEDER AL PACK RECONEXIÓN]</span>
              <span className="block text-sm font-normal mt-1 opacity-90" data-id="element-57">
                $19.990 ARS · Acceso inmediato
              </span>
            </CTAButton>
          </motion.div>

          {/* 5. Bullet points */}
          <motion.ul variants={containerVariants} className="space-y-4 max-w-2xl mx-auto pt-4" data-id="element-58">
            {['7 Días Estructurados: Chau a la improvisación y los gritos.', 'Mecanismos de Validación Positiva: Bajá sus defensas en minutos.', 'Kit de Supervivencia Táctica: Salidas, calle, ansiedad y rebeldía bajo control.', 'Descargás. Aplicás. Recuperás a tu hijo.'].map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start space-x-3" data-id="element-59">
                <CheckCircle2 className="w-6 h-6 text-terracotta flex-shrink-0 mt-0.5" data-id="element-60" />
                <span className="text-gray-800 font-medium" data-id="element-61">{item}</span>
              </motion.li>)}
          </motion.ul>
        </motion.div>
      </div>
    </section>;
}